var map = {
	"./cursed_finger.webm": 4521,
	"./dev3.webm": 8319,
	"./dev4.webm": 9490,
	"./dev5.webm": 305,
	"./dev6.webm": 1620,
	"./th3d.webm": 9520,
	"./thdev.webm": 132,
	"./thvid.webm": 5196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8920;